export default __webpack_public_path__ + "static/apparel-a99e496147e22d2967575b59cec8048c.png";